import picturefill from 'picturefill';

import Sharer from './modules/share/sharer';
//import VariantCarousel from './modules/variantcarousel/variantcarousel';
//import ValidateForms from './modules/forms/validate';
//import EnquiryForms from './modules/forms/enquiry-forms';
//import Modals from './modules/modals/modals';
//import QuoteReq from './modules/quote-req/quote-req';

import AOS from 'aos';

AOS.init({
    duration: 250,
    delay: 0,
    once: true,
});

const thankYou = document.getElementById("thank-you");

if(thankYou) {
    console.log('thank you')
    thankYou.scrollIntoView({ behavior: 'smooth', block: 'start' });

}